// Alle Varianten-Komponenten. Auf der Produktseite koennen zwei davon gleichzeitig
// dasselbe Produkt bedienen: die Swatches im Kaufbereich und die Dropdowns der
// Sticky-Leiste. Sie muessen sich gegenseitig nachziehen, sonst zeigen sie
// unterschiedliche Varianten an - und je nach Button landet die falsche im Warenkorb.
const VARIANT_COMPONENTS = 'product-variant-swatch, product-variant-dropdown, product-variant-selects-stick';

// Beim Spiegeln loesen wir echte change-Ereignisse aus, damit auch fremde Handler
// (z. B. die Beschriftung .variant_current) mitbekommen, was passiert ist. Die
// Schwester-Komponente laeuft dadurch ihrerseits in onVariantChange - dieses Flag
// verhindert, dass sie zurueckspiegelt und beide sich gegenseitig hochschaukeln.
let variantSyncRunning = false;

class ProductVariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateAuswahlhilfe();
      this.updateTextslots();
      this.updateVariantInput();
      this.renderProductInfo();
      if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
        this.updateURL();
      }
    }
    // Bewusst ausserhalb von if/else: auch eine nicht lieferbare Kombination muss
    // ankommen, sonst behaelt die Sticky-Leiste ihren aktiven Kaufen-Button.
    this.syncSiblings();
  }

  // Die eigene Auswahl auf alle anderen Komponenten desselben Produkts uebertragen.
  // Der Quick-View bleibt aussen vor: er traegt eine eigene data-product-id
  // ("templateQV") und meint ein anderes Produkt.
  syncSiblings() {
    if (variantSyncRunning || !this.options) return;
    variantSyncRunning = true;
    try {
      document.querySelectorAll(VARIANT_COMPONENTS).forEach((other) => {
        if (other === this || other.dataset.productId !== this.dataset.productId) return;
        if (typeof other.applyOptions === 'function') other.applyOptions(this.options);
      });
    } finally {
      variantSyncRunning = false;
    }
  }

  // Optionswerte von aussen setzen. Diese Variante bedient <select>; die Swatch-Klasse
  // ueberschreibt sie fuer Radio-Buttons.
  applyOptions(values) {
    Array.from(this.querySelectorAll('select')).forEach((select, index) => {
      if (values[index] === undefined || select.value === values[index]) return;
      select.value = values[index];
      // Echtes Ereignis statt direktem Methodenaufruf: daran haengt neben unserem
      // eigenen Handler auch die Beschriftung neben dem Optionsnamen.
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.productId}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    const itemact = document.querySelectorAll('.proFeaturedImage .item');
    for (var i = 0; i < itemact.length; i++) {
      itemact[i].classList.remove('act')
    }
    newMedia.classList.add('act');
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // Ohne data-product-url stand hier "undefined?variant=123" in der Adresszeile.
    // Betrifft product-variant-selects-stick: die Sticky-Leiste liefert data-url und
    // data-section statt data-product-url und data-product-id.
    if (!this.dataset.productUrl) return;
    window.history.replaceState({ }, '', `${this.dataset.productUrl}?variant=${this.currentVariant.id}`);
  }

  // Die <option> der aktuell gewaehlten Variante in der versteckten Liste - Quelle fuer
  // SKU und Bestandsdaten.
  //
  // Frueher stand an den Aufrufstellen document.getElementById('productSelect') und
  // document.getElementById('variant_id'). Beides war doppelt falsch:
  //
  // 1. Produktseite und Quick-View bringen jeweils eine eigene Liste mit derselben ID mit.
  //    getElementById nahm die erste im Dokument, im Quick-View also die des Produkts
  //    dahinter. Fuer ein fremdes Produkt fand die Suche nichts, und das direkt
  //    angehaengte getAttribute() warf einen TypeError - der Rest der Methode lief nicht
  //    mehr. Deshalb jetzt ueber data-variant-select-for, passend zum data-product-id
  //    dieser Komponente.
  // 2. Die Varianten-ID kam aus getAttribute('value') des versteckten Feldes.
  //    updateVariantInput() setzt dort aber input.value, also die Property - das Attribut
  //    bleibt auf dem beim Rendern gesetzten Wert stehen. SKU und Preorder-Label rechneten
  //    damit immer mit der ERSTEN Variante. this.currentVariant.id ist ohnehin genauer.
  variantOption() {
    if (!this.currentVariant) return null;
    const select = document.querySelector(`[data-variant-select-for="${this.dataset.productId}"]`)
      || document.getElementById('productSelect');
    if (!select) return null;
    return select.querySelector(`[value="${this.currentVariant.id}"]`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('fieldset')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId;
    fetch(`${this.dataset.productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPrice-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
        const option = this.variantOption();
        const variantSku = document.getElementById('variantSku');
        if (option && variantSku) {
          variantSku.textContent = option.getAttribute('data-sku') || '';
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const option = this.variantOption();
      const inventoryPolicy = option && option.getAttribute('data-inventory_policy');
      const qty_inventory = option ? Number(option.getAttribute('data-qty_inventory')) : 0;
      if (addButtonText) {
        addButtonText.textContent = (inventoryPolicy === 'continue' && qty_inventory < 0)
          ? window.variantStrings.preorder
          : window.variantStrings.addToCart;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
  }
  setUnavailable() {
    // Reihenfolge beachten: die Pruefung auf addButton stand frueher NACH dem Zugriff
    // darauf - bei fehlendem Formular (Quick-Add, Sticky-Leiste) knallte es also, bevor
    // der Guard griff.
    const addButton = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  connectedCallback() {
    // Initial gewaehlte Variante beim Laden auf die Slots und die Auswahlhilfe anwenden.
    try {
      this.updateOptions();
      this.updateMasterId();
      this.updateAuswahlhilfe();
      this.updateTextslots();
    } catch (e) {/* DOM/JSON evtl. noch nicht bereit -> stumm ignorieren */ }
  }

  getAuswahlhilfeData() {
    if (this._vah) return this._vah;
    const el = document.getElementById(`variant-auswahlhilfe-${this.dataset.productId}`);
    try { this._vah = el ? JSON.parse(el.textContent) : {}; } catch (e) { this._vah = {}; }
    return this._vah;
  }

  updateAuswahlhilfe() {
    // Ziele bewusst nur INNERHALB dieser Komponente -> Produktseite und Quick-View kollidieren nicht.
    const targets = this.querySelectorAll('[data-variant-help-index]');
    if (!targets.length) return;
    const list = (this.currentVariant && this.getAuswahlhilfeData()[this.currentVariant.id]) || [];
    targets.forEach((el) => {
      const text = Array.isArray(list) ? list[Number(el.dataset.variantHelpIndex)] : null;
      if (text && text !== '-') {
        el.textContent = text;                                       // textContent statt innerHTML -> sicher
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;                                            // kein Resttext der vorherigen Variante
      }
    });
  }

  getTextslotData() {
    if (this._vts) return this._vts;
    const el = document.getElementById(`variant-textslots-${this.dataset.productId}`);
    try { this._vts = el ? JSON.parse(el.textContent) : {}; } catch (e) { this._vts = {}; }
    return this._vts;
  }

  updateTextslots() {
    // Slots stehen in den Accordion-Bloecken, also ausserhalb dieser Komponente -> dokumentweit suchen.
    const slots = document.querySelectorAll('[data-vslot]');
    if (!slots.length) return;                                        // Marker nicht gepflegt -> nichts tun
    const data = (this.currentVariant && this.getTextslotData()[this.currentVariant.id]) || {};

    // Ein Slot kann aus mehreren Elementen bestehen (Stil 'li': eine Zeile = ein Punkt),
    // deshalb erst nach Schluessel gruppieren.
    const groups = new Map();
    slots.forEach((el) => {
      const key = el.dataset.vslot;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(el);
    });

    groups.forEach((els, key) => {
      const markup = data[key];
      if (!markup) return;                                            // kein Eintrag -> DOM unveraendert lassen
      els.slice(1).forEach((el) => el.remove());                      // Reste der vorherigen Variante
      // outerHTML statt innerHTML: das Markup bringt seine eigene Huelle mit und darf
      // aus einem Element mehrere machen. Bei leerem Slot kommt eine versteckte Huelle
      // zurueck, damit der Slot beim naechsten Wechsel wieder auffindbar ist.
      els[0].outerHTML = markup;
    });
  }
}
customElements.define('product-variant-dropdown', ProductVariantDropdown);

class ProductVariantSwatch extends ProductVariantDropdown {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
  // Swatches statt <select>: den passenden Radio-Button anhaken.
  applyOptions(values) {
    Array.from(this.querySelectorAll('fieldset')).forEach((fieldset, index) => {
      if (values[index] === undefined) return;
      const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
        .find((input) => input.value === values[index]);
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}

customElements.define('product-variant-swatch', ProductVariantSwatch);

class ProductVariantSelectsStick extends ProductVariantDropdown {
  constructor() {
    super();
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-sticky-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(`${this.dataset.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPriceStick-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-sticky-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const option = this.variantOption();
      const inventoryPolicy = option && option.getAttribute('data-inventory_policy');
      const qty_inventory = option ? Number(option.getAttribute('data-qty_inventory')) : 0;
      if (addButtonText) {
        addButtonText.textContent = (inventoryPolicy === 'continue' && qty_inventory < 0)
          ? window.variantStrings.preorder
          : window.variantStrings.addTobag;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
  }
  setUnavailable() {
    // Guard vor dem Zugriff - siehe Basisklasse.
    const addButton = document.getElementById(`product-form-sticky-${this.dataset.productId}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
}

customElements.define('product-variant-selects-stick', ProductVariantSelectsStick);
